import { select, getData, addClass, removeClass, on, setStyle, selectAll, getHeight, hasClass } from 'modules/dom'
import { map, curry } from 'modules/utils'
import Flickity from 'flickity'
import debounce from 'lodash.debounce'
var Promise = require('es6-promise').Promise

const INITIAL_CLASS = 'is-initialized'

const addInitial = addClass(INITIAL_CLASS)
const removeInitial = removeClass(INITIAL_CLASS)

function Carousel (el) {
  var t = this
  t.el = el
  if (el && el.childElementCount > 1) {
    const customOptions = JSON.parse(getData('options', el))
    if (customOptions) {
      const setHeightForItems = curry((items, height) => map((item) => setStyle('height', height + 'px', item), items))
      const resetHeightForItems = (items) => {
        map((item) => setStyle('height', 'auto', item), items)
        return items
      }
      const maxHeightOfArray = arr => Math.max.apply(null, map((item) => getHeight(item), arr))
      const items = selectAll('.card-post', el)
      const setHeightForContentInner = () => {
        if (items.length > 0) {
          const resetHeight = new Promise((resolve) => {
            resolve(resetHeightForItems(items))
          })
          resetHeight.then(
            items => {
              const maxHeight = maxHeightOfArray(items)
              setHeightForItems(items, maxHeight)
              setStyle('height', maxHeight + 'px', select('.flickity-viewport', el))
            }
          )
        }
      }
      const windowResize = () => {
        removeInitial(el)
        if (window.innerWidth >= 1280 && items.length > 0) {
          resetHeightForItems(items)
        }
        addInitial(el)
      }
      const flickyReady = () => {
        addInitial(el)
        setHeightForContentInner()
      }
      customOptions.on = {
        ready: flickyReady,
        resize: setHeightForContentInner
      }
      const slider = new Flickity(el, customOptions)
      t.slider = slider

      // previous
      const whatsNewEl = select('.js-whats-new-head')
      if (whatsNewEl && hasClass('whats-new__carousel', el)) {
        const prev = select('.js-button-previous', whatsNewEl)
        const next = select('.js-button-next', whatsNewEl)
        if (prev && next) {
          on('click', (e) => {
            slider.previous()
          }, prev)

          on('click', (e) => {
            slider.next()
          }, next)

          slider.on('select', () => {
            if ( !slider.cells[ slider.selectedIndex - 1 ] ) {
              prev.disabled = true
              next.disabled = false
            } else if ( !slider.cells[ slider.selectedIndex + 1 ] ) {
              prev.disabled = false
              next.disabled = true
            } else {
              prev.disabled = false
              next.disabled = false
            }
          })
        }
      }

      on('resize', debounce(windowResize), window)
      const resetHeightCarousel = () => {
        removeInitial(el)
        slider.resize()
        slider.reloadCells()
        addInitial(el)
      }
      if (el.hasAttribute('data-initialize')) {
        on('resize', resetHeightCarousel, window)
        on('load', debounce(resetHeightCarousel), window)
      }
      const syncSliderEl = select(getData('sync-carousel', el))
      if (syncSliderEl) {
        const syncSliderOption = JSON.parse(getData('options', syncSliderEl))
        const syncSlider = new Flickity(syncSliderEl, syncSliderOption)
        const adjustHeight2 = () => {
          syncSlider.resize()
          syncSlider.reloadCells()
          addInitial(syncSliderEl)
        }
        const resetHeight2 = () => {
          removeInitial(syncSliderEl)
          adjustHeight2()
        }
        on('load', resetHeight2, window)
        on('resize', debounce(resetHeight2), window)
        slider.on('select', () => syncSlider.select(slider.selectedIndex))
      }
    }
  }
}

const focus = Flickity.prototype.focus
Flickity.prototype.focus = function() {
  // use non-standard setActive for IE11. #651
  if ( this.element.setActive  ) {
    this.element.setActive()
    return
  }
  // use default
  focus.apply( this, arguments )
}

Carousel.prototype.destroy = function () {
  var t = this
  if (t.slider) {
    removeInitial(t.el)
    t.slider.destroy()
  }
  return false
}

module.exports = Carousel
